module.exports = "https://cdn-shared.mathletics.com/mathsaz/100/assets/images/3ef782b2da8a91ed0951d8df6505f532.svg";